import {
  isStatus,
  isStatusErr,
} from '../../Utils/Response/Response';
import { PRODUCT_KEY_ACCOUNT_URL } from '../EndPoint';
import * as BaseAPI from './BaseAPIs';

export const postProductKeyAccountCountData = (token, notify, dispatch, action) =>
  BaseAPI.doPost(PRODUCT_KEY_ACCOUNT_URL.COUNT, token, null, notify, dispatch, res => action(res));


export const postProductKeyAccountList = (token, page, limit, sortDate,notify,dispatch,action) =>
  BaseAPI.doPost(PRODUCT_KEY_ACCOUNT_URL.LIST(page, limit, sortDate), token, null,notify,dispatch,(res)=>action(res));


export const postRejectProductKeyAccountList = (token, data,notify,dispatch) => 
  BaseAPI.doPost(PRODUCT_KEY_ACCOUNT_URL.REJECT, token, data,notify,dispatch,
    res=>isStatus(res),err=>isStatusErr(err))

export const getDetailProductKeyAccount = (token, id,notify,dispatch,action,errAction) => 
  BaseAPI.doGet(PRODUCT_KEY_ACCOUNT_URL.DETAIL + id, token, null,null,notify,dispatch,
  res=>action(res),err=>errAction(err));

export const getDetailExistingProductKeyAccount = (token, id,notify,dispatch,action,errAction) => 
  BaseAPI.doGet(PRODUCT_KEY_ACCOUNT_URL.DETAIL_EXISTING + id, token, null,null,notify,dispatch,
  res=>action(res),err=>errAction(err));


export const postSearchProductKeyAccountList = (token, data,dispatch, notify,action,errAction) => {
  return BaseAPI.doPost(PRODUCT_KEY_ACCOUNT_URL.SEARCH,  token, data ,notify,dispatch,
    (res)=>action(res),err=>errAction(err));
};
export const postApproveMappingProductKeyAccount = (token, data,notify,dispatch,action,errAction) => {
  return BaseAPI.doPost(PRODUCT_KEY_ACCOUNT_URL.MAPPING_APPROVE, token, data,notify,dispatch,
      (res)=>action(res),err=>errAction(err));
};
export const postProductKeyAccountSearchCountData = (token,data,notify,dispatch,action) =>  
  BaseAPI.doPost(PRODUCT_KEY_ACCOUNT_URL.COUNT_SEARCH, token, data,notify,dispatch,(res)=>action(res));